import React, { useState, useEffect, Fragment } from "react";
import makeStyles from '@mui/styles/makeStyles';
import {Typography, TextField, MenuItem, Divider, CircularProgress, Grid, IconButton} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import LoginMenu from "../../../../../components/LoginMenu/LoginMenu";
import CustomizedSnackbar from "../../../../../components/CustomizedSnackbar/CustomizedSnackbar";
import BottomBar from "../../../../../components/BottomBar/BottomBar";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const useStyles = makeStyles({});

const R46Reports = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showTableFilter, setShowTableFilter] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [isDownloadPdf, setIsDownloadPdf] = useState(false);
  const [applicationStatusId, setApplicationStatusId] = useState(1);
  const [isLoginMenu, setIsLoginMenu] = useState(false);
  const [isReload, setIsReload] = useState(false);
  const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [fromDate, setFromDate] = useState(new Date());
  const [fromDateError, setFromDateError] = useState("");
  const [toDate, setToDate] = useState(new Date());
  const [toDateError, setToDateError] = useState("");

  const handleOpenSnackbar = (msg, severity) => {
    setIsOpenSnackbar(true);
    setSnackbarMessage(msg);
    setSnackbarSeverity(severity);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") { return; }
    setIsOpenSnackbar(false);
  };

  const handleChangeFromDate = (date) => {
    setFromDate(date);
  };

  const handleChangeToDate = (date) => {
    setToDate(date);
  };

  const onHandleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    if (name === "fromDate") {
      setFromDate(value);
      setFromDateError("");
    } else if (name === "toDate") {
      setToDate(value);
      setToDateError("");
    }
  };

  const handleGenerate = () => {
    let fromDateValue = new Date(fromDate).getTime();
    let toDateValue = new Date(toDate).getTime();
    console.log(fromDateValue + "-" + toDateValue);
    window.open(`#/R114ReportsAttendanceRecordSheet/${fromDateValue+"&"+toDateValue}`,"_blank");
  };

  useEffect(() => {
    props.setDrawerOpen(false);
  }, []);

  return (
    <Fragment>
      <LoginMenu
        reload={isReload}
        open={isLoginMenu}
        handleClose={() => setIsLoginMenu(false)}
      />
      <div
        style={{
          padding: 20
        }}
      >
        <div style={{ marginBottom: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
            <IconButton
              onClick={() => navigate('/dashboard')}
              style={{ marginRight: 10, color: "#1d5f98" }}
              size="large"
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography
              style={{
                color: "#1d5f98",
                fontWeight: 600,
                textTransform: "capitalize",
                borderBottom: "1px solid rgb(58, 127, 187, 0.3)",
                flex: 1
              }}
              variant="h5"
            >
              Attendance Record
            </Typography>
          </div>
          <div style={{ display: 'flex', gap: 16 }}>
            <div style={{ flex: 1 }}>
              <DatePicker
                name="fromDate"
                id="fromDate"
                label="From Date *"
                format="dd-MM-yyyy"
                value={fromDate}
                onChange={handleChangeFromDate}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    error: !!fromDateError,
                    helperText: fromDateError
                  }
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <DatePicker
                name="toDate"
                id="toDate"
                label="To Date *"
                format="dd-MM-yyyy"
                value={toDate}
                onChange={handleChangeToDate}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    error: !!toDateError,
                    helperText: toDateError
                  }
                }}
              />
            </div>
          </div>
        </div>
        <BottomBar
          left_button_text="View"
          leftButtonHide={true}
          bottomLeftButtonAction={undefined}
          rightButtonText="Genrate"
          rightButtonAction={handleGenerate}
          loading={isLoading}
          isDrawerOpen={props.isDrawerOpen}
        />
        <CustomizedSnackbar
          isOpen={isOpenSnackbar}
          message={snackbarMessage}
          severity={snackbarSeverity}
          handleCloseSnackbar={() => handleCloseSnackbar()}
        />
      </div>
    </Fragment>
  );
};

export default R46Reports;
